export default {"src":"/_next/static/media/dumpster-rental.aeaa463e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};